"use client";

import { useLingui } from "@lingui/react/macro";
import { Footer } from "@/components/global-sections/footer";
import { useFooterData } from "@/components/global-sections/footer/fixture";

const LEGACY_FOOTER_INFO_LINK_IDS: Record<string, string> = {
  link_footer_info_terms: "link_drlp_legacy_footer_info_terms",
  link_footer_info_privacy: "link_drlp_legacy_footer_info_privacy",
  link_footer_info_security: "link_drlp_legacy_footer_info_security",
};

export function DrlpFooter({ legacy }: { legacy: boolean }) {
  const { t } = useLingui();
  const { footerInfoLinks } = useFooterData();
  // DRLPs are paid landing pages, so the global footer's sitemap columns are
  // dropped — only a home link plus the legal/info links remain (mirrors the fin
  // DRLP footer).
  const drlpFooterLinks = [
    {
      title: t`Home`,
      href: "/",
      analyticsId: legacy
        ? "link_drlp_legacy_footer_info_home"
        : "link_drlp_footer_info_home",
    },
    ...footerInfoLinks.map((link) =>
      legacy
        ? {
            ...link,
            analyticsId:
              LEGACY_FOOTER_INFO_LINK_IDS[link.analyticsId] ?? link.analyticsId,
          }
        : link,
    ),
  ];

  return (
    <Footer
      minimalFooter
      infoLinks={drlpFooterLinks}
      className="text-body-sm **:[a]:text-body-mobile! **:[button]:text-body-mobile!"
    />
  );
}
